<div
  class="root-container"
  [ngClass]="
    showSearchField
      ? 'header-container header-container-with-search'
      : 'header-container'
  "
>
  <div class="w-100">
    <header
      class="header navbar navbar-expand-lg bg-body-tertiary"
      role="banner"
    >
      <div class="header-components">
        <div class="logo-container">
          <a
            class="header-logo navbar-brand"
            href=""
            aria-label="Grupo San Cristobal inicio"
          >
            <img class="img-logo" [src]="logoGsc" alt="Grupo San Cristobal" />
            <span class="img-logo_title">Mi Portal</span>
            <img
              class="img-logo-mobile"
              [src]="logoGscMobile"
              alt="Grupo San Cristobal"
            />
          </a>
        </div>
        <button
          class="navbar-toggler border-0 burger"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarToggleExternalContent"
          aria-controls="navbarToggleExternalContent"
          aria-expanded="false"
          aria-label="Abrir el menú de navegación"
        >
          <img
            src="../../../../assets/images/iconmenuburger.svg"
            width="30"
            height="30"
            alt="Icono de menú"
          />
        </button>

        <nav
          class="header-nav collapse navbar-collapse"
          id="navbarSupportedContent"
          aria-label="Navegación principal"
        >
          <div class="input-container-desktop">
            <ul class="header-nav-buttons navbar-nav">
              <li
                class="header-link nav-item"
                *ngFor="let item of items; let i = index"
              >
                <a
                  [id]="item.id"
                  class="nav-link"
                  [href]="item.link"
                  [attr.aria-label]="item.title"
                >
                  {{ item.title }}
                </a>
                <img
                  class="header-link-bar"
                  src="../../../assets/images/menu-item-background.svg"
                  alt="imagen decorativa menú"
                  aria-hidden="true"
                />
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>

    <div class="collapse" id="navbarToggleExternalContent">
      <nav aria-label="Navegación principal">
        <ul class="navbar-nav">
          <li
            class="nav-item-mobile"
            *ngFor="let item of items; let i = index"
          >
            <a
              [id]="item.id"
              class="nav-link"
              [href]="item.link"
              [attr.aria-label]="item.title"
            >
              {{ item.title }}
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
  <div class="input-search-container" *ngIf="showSearchField">
    <ng-container [ngTemplateOutlet]="searchField"></ng-container>
  </div>
</div>

<ng-template #searchField>
  <sc-search-field
    class="benefit-search input-search-container input-group search-field"
    (search)="searchBenefits($event)"
    (onChangeText)="searchWhenTextChange($event)"
    [placeholder]="placeholder"
    aria-label="Campo de búsqueda"
  ></sc-search-field>
</ng-template>
